export enum ClaimType {
  ROLES = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
};